import { render, staticRenderFns } from "./ManageCategories.vue?vue&type=template&id=cdecd5dc&"
import script from "./ManageCategories.vue?vue&type=script&lang=ts&"
export * from "./ManageCategories.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports